module.exports = __webpack_public_path__ + "static/mary-kay-bg-1d0ba29c7fde5c415cd830433029fa3a.png";